export const API_ENDPOINTS = {
	LIST_REQUESTS: '/dashboard/miscellaneous-suspiciousTransactions-listSuspiciousTransactionsRequests',
	CREATE_REQUEST: '/dashboard/miscellaneous-suspiciousTransactions-createSuspiciousTransactionsRequest'
} as const;

export const ENTITIES = {
	SUSPICIOUS_TX: 'SUSPICIOUS_TX'
} as const;

export const LIST_COL_NAMES = {
	STATUS: 'status',
	CREATED_AT: 'createdAt',
	UPDATED_AT: 'updatedAt',
	DOWNLOAD_URL: 'downloadUrl'
} as const;

export const DEFAULT_PAGINATION = {
	DEFAULT_PAGE_SIZE: 20,
	STATUS_PAGE_SIZE: 50
} as const;
